import React from 'react'
import '../styles/disturber.css';

const Disturber = props => (
    <div className="disturber">
        Informationen zu den Energiepreisbremsen können Sie unten im Downloadbereich herunterladen.
    </div>
)
export default Disturber;


// WEBPACK FOOTER //
// ./src/components/Disturber.js